"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryParamToNumberStrict = exports.queryParamToNumber = exports.queryParamToBooleanStrict = exports.queryParamToBoolean = exports.queryParamToStringStrict = exports.queryParamToString = void 0;
function queryParamToString(param) {
    if (Array.isArray(param)) {
        throw new Error(`Query parameter is array. Should be string.`);
    }
    return param;
}
exports.queryParamToString = queryParamToString;
function queryParamToStringStrict(param) {
    const paramOrUndefined = queryParamToString(param);
    if (paramOrUndefined === undefined) {
        throw new Error("Parameter not found.");
    }
    return paramOrUndefined;
}
exports.queryParamToStringStrict = queryParamToStringStrict;
function queryParamToBoolean(param) {
    if (Array.isArray(param)) {
        throw new Error(`Query parameter is array. Should be string.`);
    }
    if (param === undefined) {
        return undefined;
    }
    if (param === "true") {
        return true;
    }
    if (param === "false") {
        return false;
    }
    throw new Error(`Parameter should be boolean (true|false). Given '${param}'.`);
}
exports.queryParamToBoolean = queryParamToBoolean;
function queryParamToBooleanStrict(param) {
    const paramOrUndefined = queryParamToBoolean(param);
    if (paramOrUndefined === undefined) {
        throw new Error("Parameter not found.");
    }
    return paramOrUndefined;
}
exports.queryParamToBooleanStrict = queryParamToBooleanStrict;
function queryParamToNumber(param) {
    if (Array.isArray(param)) {
        throw new Error(`Query parameter is array. Should be number.`);
    }
    if (param === undefined) {
        return undefined;
    }
    const numberParam = Number.parseInt(param, 10);
    if (Number.isNaN(numberParam)) {
        throw new Error("Query parameter is NaN. Should be number.");
    }
    return numberParam;
}
exports.queryParamToNumber = queryParamToNumber;
function queryParamToNumberStrict(param) {
    const paramOrUndefined = queryParamToNumber(param);
    if (paramOrUndefined === undefined) {
        throw new Error("Parameter not found.");
    }
    return paramOrUndefined;
}
exports.queryParamToNumberStrict = queryParamToNumberStrict;
